import { getItem, setItem, removeItem } from './scopedSettingsStorage';

const DRAFT_KEY_PREFIX = 'composer_draft:';
const DRAFT_SESSION_FALLBACK = '__new__';
/** Long prompts are the ones worth keeping; storage is not an archive. */
const MAX_DRAFT_CHARS = 20000;

function draftKey(sessionId: string | null | undefined): string {
  return `${DRAFT_KEY_PREFIX}${sessionId || DRAFT_SESSION_FALLBACK}`;
}

/**
 * Per-session composer draft.
 *
 * A half-written requirement is often several minutes of an engineer's thinking;
 * switching sessions or reloading must not throw it away.
 */
export function readComposerDraft(sessionId: string | null | undefined): string {
  return getItem(draftKey(sessionId)) || '';
}

export function writeComposerDraft(sessionId: string | null | undefined, text: string): void {
  const key = draftKey(sessionId);
  if (!text.trim()) {
    removeItem(key);
    return;
  }
  setItem(key, text.slice(0, MAX_DRAFT_CHARS));
}

export function clearComposerDraft(sessionId: string | null | undefined): void {
  removeItem(draftKey(sessionId));
}
